import { describeFields, FieldWidget } from '../common/fields';
import { StudentSchema } from './schemas';

export const STUDENT_FIELDS = describeFields(StudentSchema, {
  id: {},
  // Every state: a form offers only those its student may move to
  state: {},
  firstName: {},
  lastName: {},
  schoolId: {},
  schoolLabel: {},
  schoolShortLabel: {},
  gradYear: {},
  birthday: { widget: FieldWidget.Date },
  email: {},
  phoneNumber: {},
  parentFirstName: {},
  parentLastName: {},
  parentEmail: {},
  parentPhoneNumber: {},
  streetAddress: {},
  country: {},
  postcode: {},
  disabled: { widget: FieldWidget.Text },
  classes: {},
  tutorials: {},
  profileIcon: {},
  settings: {},
  slackUserId: {},
  slackChannelIds: {},
  xeroContactId: {},
  discounts: {},
  courseStates: {},
  requiresInvoice: { widget: FieldWidget.Text },
  requiresRefund: { widget: FieldWidget.Text },
  attendanceType: {},
  invoiceInstallmentCount: {},
});
